import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'

const options = {
  themes: {
    tooltip: {
      delay: { show: 150, hide: 0 },
      distance: 8,
    },
  },
}

export default (app) => {
  app.use(FloatingVue, options)
}
